var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.955 19.955C17.8452 22.0647 14.9837 23.25 12 23.25C9.01632 23.25 6.15483 22.0647 4.04505 19.955C1.93526 17.8452 0.75 14.9837 0.75 12C0.75 9.01632 1.93526 6.15483 4.04505 4.04505C6.15483 1.93526 9.01632 0.75 12 0.75C14.9837 0.75 17.8452 1.93526 19.955 4.04505C22.0647 6.15483 23.25 9.01632 23.25 12C23.25 14.9837 22.0647 17.8452 19.955 19.955Z",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28063 15.1892V8.21077C9.27923 8.09162 9.30988 7.97428 9.36939 7.87105C9.42889 7.76781 9.51506 7.68247 9.61887 7.62396C9.72267 7.56546 9.8403 7.53593 9.95943 7.53848C10.0786 7.54103 10.1948 7.57556 10.296 7.63846L16.3329 11.1277C16.4325 11.1864 16.5149 11.2701 16.5722 11.3705C16.6295 11.4709 16.6597 11.5844 16.6597 11.7C16.6597 11.8156 16.6295 11.9291 16.5722 12.0295C16.5149 12.1299 16.4325 12.2136 16.3329 12.2723L10.296 15.8538C10.188 15.9232 10.0623 15.9598 9.93397 15.9593C9.80565 15.9587 9.68022 15.921 9.57285 15.8507C9.46548 15.7805 9.38075 15.6806 9.32889 15.5632C9.27704 15.4458 9.26028 15.3159 9.28063 15.1892Z",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveVideo);
export default __webpack_public_path__ + "static/media/live-video.2b709a52fa5cbb2f7081d445228c1762.svg";
export { ForwardRef as ReactComponent };